import dayjs from 'dayjs';

export default function calculateTrackingEndDate(
  endDate: string | number | Date | dayjs.Dayjs
) {
  return dayjs(endDate).add(12, 'month').format('YYYY-MM-DD');
}
